<template>
    <div>
        <div class="top-title">
            <h3>{{ $t("message.questionary") }}</h3>
        </div>
        <div class="modal-tasks-itle">
            <el-row v-for="(question, index) in questions" :key="index">
                <el-col :span="24">
                    <h4>{{ question.name }}</h4>
                </el-col>
                <el-col :span="24">
                    <el-radio-group
                        v-model="answers[index].option_id"
                    >
                        <el-radio-button
                            v-for="option in question.options"
                            :label="option.id"
                            :key="option.id"
                            class="m-1 inline-block"
                        >{{ option.name }}</el-radio-button>
                    </el-radio-group>
                </el-col>
            </el-row>
            <el-row class="mt-3">
                <el-col :span="24">
                    <el-input v-model="comment" :placeholder="$t(`message.comment`)"></el-input>
                </el-col>
            </el-row>
            <el-row>
                <el-button
                    v-loading="onSave"
                    class="mt-5"
                    type="success"
                    @click="submit()"
                >{{ $t(`message.save`) }}</el-button>
            </el-row>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppModal from "@/views/deals/components/add-modal";

export default {
    components: {
        AppModal
    },
    data() {
        return {
            selectedDeal: null,
            board_id: null,
            dealCreate: false,
            drawerDealCreate: false,
            answers: [],
            questions: [],
            onSave: false,
            comment: '',
        };
    },
    created() {
    },
    computed: {
        ...mapGetters({
            rules: "phoneContacts/rules",
            model: "phoneContacts/model",
            columns: "phoneContacts/columns",
            list: "happyCallQuestions/list",
            client: "clients/model"
        }),
    },
    methods: {
        ...mapActions({
            save: "questionaries/store",
            loadQuestionsWithOptions: "happyCallQuestions/index",
        }),
        async afterOpen(){
            await this.loadQuestionsWithOptions({has_options: true});
            this.questions = JSON.parse(JSON.stringify(this.list));
            this.questions.forEach(question => {
                this.answers.push({
                    'question_id': question.id,
                    'option_id': null,
                })
            });
        },
        addModalEdit(deal, dealCreate) {
            this.$emit('addModalEdit', {deal, dealCreate})
        },
        submit() {
            this.onSave = true;
            this.save({
                answers: this.answers,
                client_id: this.client.id,
                comment: this.comment,
            })
                .then(res => {
                    this.$notify({
                        title: "Success",
                        type: "success",
                        message: res.data.result.message,
                        duration: 5000,
                    });
                    this.answers = null;
                    this.onSave = false;
                })
                .finally(fin => {
                    this.$parent.closeQuestionaryModal();
                })
        },
    },
};
</script>

<style>

.coloa3 {
    background: #ff3f3f;
}

</style>
